import { useEffect, useState } from "react";

export const QuickNav = ({ items }) => {
  const [active, setActive] = useState(items[0]?.id);
  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting && setActive(e.target.id));
    }, { rootMargin: "-30% 0px -60% 0px" });
    items.forEach((i) => { const el = document.getElementById(i.id); el && obs.observe(el); });
    return () => obs.disconnect();
  }, [items]);

  return (
    <nav data-testid="guide-quick-nav" className="glass rounded-2xl p-5">
      <div className="mono-label mb-3">Quick Navigation</div>
      <ul className="space-y-1 max-h-[38vh] overflow-y-auto pr-1">
        {items.map((i) => (
          <li key={i.id}>
            <a href={`#${i.id}`} data-testid={`nav-${i.id}`}
              onClick={(e) => { e.preventDefault(); document.getElementById(i.id)?.scrollIntoView({ behavior: "smooth" }); }}
              className={`block text-xs font-mono py-1.5 pl-3 border-l transition-colors ${active === i.id ? "border-cyan-300 text-cyan-300" : "border-white/10 text-slate-400 hover:text-white"}`}>
              {i.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
